import styled from 'styled-components';

export const AllowanceLabelRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.25rem;
`;
